import {
  ApplicationRef,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  EventEmitter, Inject,
  Injectable, Injector,
  TemplateRef,
  Type
} from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { Parser } from 'maf-web';
import { ToastrService} from 'ngx-toastr';
import { ConsumidorSiteClientModelService } from './service/consumidorsiteclient.model.service';
import { ParametrosModelService } from './service/parametros.model.service';
import { DataParametrosAPP, ConsClienteAPP, ConsLojasComVendedorAPP, PKDependenteAPP, ConsumidorSiteResponseGetConsumidorV0APP } from './vo/sitevo.vo';

declare global {
  interface Window {
    lojaLogoBase64: string;
    lojaFantasia: string;
    lojaTelefone: string;
    lojaWhatsApp: string;
    lojaVersaoPagarme: string;
  }
}

@Injectable()
export class AppService {

  private _lojaLogoBase64: string = window.lojaLogoBase64;
  private _lojaFantasia: string = window.lojaFantasia;
  private _lojaTelefone: string = window.lojaTelefone;
  private _lojaWhatsApp: string = window.lojaWhatsApp;
  private _lojaVersaoPagarme: string = window.lojaVersaoPagarme;
  private _TOKEN_LOCAL_STORAGE: string = 'tokenConsumidor';
  private _CPF_TOKEN_LOCAL_STORAGE: string = 'cpfTokenConsumidor';
  private _NOME_CONTEXTO_VITRINE_LOCAL_STORAGE: string = 'nomeContextoVitrine';
  private _parametrosAPP: DataParametrosAPP;
  private _consCliente: ConsClienteAPP;
  private _lojas: ConsLojasComVendedorAPP;
  private _lojaSelecionada: number = 0;
  private _lojaUrlVoltar: string = '';
  private _isMobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(navigator.appVersion);
  private _logoutChange: EventEmitter<boolean> = new EventEmitter();
  private _modalConfirmacao: boolean = false;
  private _cpfLoginParaCadastro: string = '';
  private _startURL: string[] = [];
  private _nomeContextoVitrine: string = '';
  private _consumidorSiteResponse: ConsumidorSiteResponseGetConsumidorV0APP;

  /********** EventEmitter **********/
  modalConfirmacaoEvent: EventEmitter<boolean> = new EventEmitter();

  /********** Métodos GET e SET **********/
  get lojaLogoBase64(): string { return this._lojaLogoBase64; }
  get lojaFantasia(): string { return this._lojaFantasia; }
  get lojaTelefone(): string { return this._lojaTelefone && this._lojaTelefone.length > 8 ? this._lojaTelefone : ''; }
  get lojaWhatsApp(): string { return this._lojaWhatsApp && this._lojaWhatsApp.length === 11 ? this._lojaWhatsApp : ''; }
  get lojaVersaoPagarme(): string { return this._lojaVersaoPagarme; }

  get tokenLocalStorage(): string { return this._TOKEN_LOCAL_STORAGE; }
  get cpfTokenLocalStorage(): string { return this._CPF_TOKEN_LOCAL_STORAGE; }

  get parametrosAPP(): DataParametrosAPP { return this._parametrosAPP; }
  set parametrosAPP(parametros: DataParametrosAPP) { this._parametrosAPP = parametros; }

  get consCliente(): ConsClienteAPP { return this._consCliente; }
  set consCliente(consCli: ConsClienteAPP) { this._consCliente = consCli; }

  get lojas(): ConsLojasComVendedorAPP { return this._lojas; }
  set lojas(lojas: ConsLojasComVendedorAPP) { this._lojas = lojas; }

  get lojaSelecionada(): number { return this._lojaSelecionada; }
  set lojaSelecionada(loja: number) { this._lojaSelecionada = loja; }

  get lojaUrlVoltar(): string { return this._lojaUrlVoltar; }
  set lojaUrlVoltar(url: string) { this._lojaUrlVoltar = url; }

  get isMobile(): boolean { return this._isMobile; }

  get logoutChange(): EventEmitter<boolean> { return this._logoutChange; }

  get modalConfirmacao(): boolean { return this._modalConfirmacao; }
  set modalConfirmacao(modal: boolean) { this._modalConfirmacao = modal; }

  get cpfLoginParaCadastro(): string { return this._cpfLoginParaCadastro; }
  set cpfLoginParaCadastro(cpf: string) { this._cpfLoginParaCadastro = cpf; }

  get startURL(): string[] { return this._startURL; }

  get urlContextoVitrine(): string {
    let urlContextoVitrine = '';
    try {
      let urlTemp: string = this.nomeContextoVitrine;
      while (urlTemp.indexOf('%') > -1) {
        urlTemp = decodeURIComponent(urlTemp);
      }
      const urlDecode: string = atob(urlTemp);
      if (urlDecode.indexOf('://') === -1) {
        throw new Error('URL error');
      }
      urlContextoVitrine = urlDecode;
    } catch (e) {
      urlContextoVitrine = 'https://vitrine.macle.com.br/' + this.nomeContextoVitrine;
    }
    return urlContextoVitrine;
  }

  get nomeContextoVitrine(): string {
    let result = this._nomeContextoVitrine;
    const ls = window.localStorage.getItem(this._NOME_CONTEXTO_VITRINE_LOCAL_STORAGE);
    if (ls && ls.length > 0) {
      result = ls;
    }
    return result;
  }
  set nomeContextoVitrine(url: string) {
    window.localStorage.setItem(this._NOME_CONTEXTO_VITRINE_LOCAL_STORAGE, url);
    this._nomeContextoVitrine = url;
  }

  get consumidorSiteResponse(): ConsumidorSiteResponseGetConsumidorV0APP { return this._consumidorSiteResponse; }
  set consumidorSiteResponse(data: ConsumidorSiteResponseGetConsumidorV0APP) { this._consumidorSiteResponse = data; }

  constructor(
    private toastrService: ToastrService,
    private consumidor: ConsumidorSiteClientModelService,
    private parametros: ParametrosModelService,
    private router: Router,
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (window.location.href.indexOf('compra') > -1) {
      this._startURL = window.location.href.substring(window.location.href.indexOf('compra')).split('/').filter(i => i.length > 0);
    } else if (window.location.href.indexOf('vitrine') > -1) {
      this._startURL = window.location.href.substring(window.location.href.indexOf('vitrine')).split('/').filter(i => i.length > 0);
    }
  }

  redirectOnLogin() {
    if ((this.startURL.length === 2 && this.startURL[1].length > 10) || (this.startURL.length === 2 && this.startURL[1] === 'item')) {
      this.router.navigate(this.startURL);
    } else {
      this.router.navigate(['/inicio']);
    }
    if (this.isConsultaEstoqueControle()) {
      this.abrirConsultaEstoqueControle();
    }
  }

  isConsultaEstoqueControle(): boolean {
    return this._consumidorSiteResponse != null && this._consumidorSiteResponse.vendedor;
  }

  abrirConsultaEstoqueControle() {
    window.open(this._consumidorSiteResponse.urlConsultaVendedor, '_blank');
  }

  setTokenEParametrosAPP(token: string, pkCliente: PKDependenteAPP, cpf: string, redirectOnLogin: boolean = true): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.consumidor.getDadosCliente(pkCliente.getPK())
        .then((data: ConsClienteAPP) => {
          if (data != null) {
            this.consCliente = data;
            window.localStorage.setItem(this.tokenLocalStorage, token);
            window.localStorage.setItem(this.cpfTokenLocalStorage, Parser.trimToDigits(cpf));
            return this.parametros.getParametrosApp();
          } else {
            return undefined;
          }
        })
        .then((data: DataParametrosAPP) => {
          if (data != null) {
            this.parametrosAPP = data;
            if (redirectOnLogin) {
              this.redirectOnLogin();
            }
          }
          resolve(true);
        })
        .catch(error => {
          console.error(error);
          reject(false);
        });
    });
  }

  logout() {
    window.localStorage.removeItem(this.tokenLocalStorage);
    window.localStorage.removeItem(this.cpfTokenLocalStorage);
    this._parametrosAPP = undefined;
    this._consCliente = undefined;
    this._logoutChange.emit(true);
  }

  removeToastrService() {
    if (this.toastrService.toasts.length > 0) {
      for (const toast of this.toastrService.toasts) {
        this.toastrService.remove(toast.toastId);
      }
      const self = this;
      setTimeout(() => self.removeToastrService(), 50);
    }
  }

  copiarCodBoleto(codBoleto: string, event: Event, cor = 1) {
    if ((event.target as HTMLDivElement).classList.contains('msg-copia')) {
      return false;
    }
    if (!navigator.clipboard) {
      this.copiarTextoParaClipboard(codBoleto);
      this.mostrarMensagemCopia(event, cor);
      return;
    }
    navigator.clipboard.writeText(codBoleto).then(() => {
      this.mostrarMensagemCopia(event, cor);
    }, (err) => {
      console.error('Nao foi possivel copiar o texto: ', err);
    });
  }

  private copiarTextoParaClipboard(texto: string) {
    const textArea = document.createElement('textarea');
    textArea.value = texto;
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand('copy');
      console.log(successful ? 'Copia feita com sucesso' : 'Nao foi feita a copia');
    } catch (err) {
      console.error('Erro ao copiar: ', err);
    }
    document.body.removeChild(textArea);
  }

  private mostrarMensagemCopia(event: Event, cor: number) {
    const mensagemDiv: HTMLDivElement = document.createElement('div');
    mensagemDiv.innerHTML = 'c&oacute;digo copiado';
    mensagemDiv.classList.add('msg-copia');
    mensagemDiv.style.position = 'absolute';
    mensagemDiv.style.display = 'flex';
    mensagemDiv.style.alignItems = 'center';
    mensagemDiv.style.justifyContent = 'center';
    mensagemDiv.style.top = '0px';
    mensagemDiv.style.left = '0px';
    mensagemDiv.style.right = '0px';
    mensagemDiv.style.bottom = '0px';
    mensagemDiv.style.padding = '0 10px';
    mensagemDiv.style.textAlign = 'center';
    mensagemDiv.style.fontWeight = 'bold';
    if (cor === 1) {
      mensagemDiv.style.border = '1px solid #eee';
      mensagemDiv.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
    }
    if (cor === 2) {
      mensagemDiv.style.border = '1px solid #fff';
      mensagemDiv.style.backgroundColor = 'rgba(238, 238, 238, 0.94)';
    }
    mensagemDiv.style.color = '#165E00';
    (event.target as HTMLDivElement).appendChild(mensagemDiv);
    setTimeout(() => mensagemDiv.remove(), 2000);
  }

  public loadComponent<T>(content: Type<T>, element: any) {
    const factory: ComponentFactory<T> = this.componentFactoryResolver.resolveComponentFactory<T>(content);
    const ngContent = this.resolveNgContent(content);
    const componentRef: ComponentRef<T> = factory.create(this.injector, ngContent);
    this.applicationRef.attachView(componentRef.hostView);
    Object.assign(componentRef.instance, {});
    componentRef.hostView.detectChanges();
    const { nativeElement } = componentRef.location;
    element.appendChild(nativeElement);
    return componentRef;
  }

  private resolveNgContent<T>(content: string | TemplateRef<any> | any) {
    if (typeof content === 'string') {
      const element = this.document.createTextNode(content);
      return [[element]];
    }
    if (content instanceof TemplateRef) {
      const viewRef = content.createEmbeddedView({});
      this.applicationRef.attachView(viewRef);
      return [viewRef.rootNodes];
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(content);
    const componentRef = factory.create(this.injector);
    Object.assign(componentRef.instance, {});
    this.applicationRef.attachView(componentRef.hostView);
    return [[componentRef.location.nativeElement]];
  }

}
